import { ApiConfig } from "common/models";
import { buildSearchApiUrl } from "common/utils/api.util";
import { KgFilterRequest } from "../models/knowledge-library.model";

export const knowledgeLibraryApiConfig = {
  kgFilter: (request: KgFilterRequest): ApiConfig => {
    return new ApiConfig(buildSearchApiUrl("kg-filter"), "POST", "", request);
  }
};
